export const getLighterColor = (hexColor: string, opacity: number = 0.1): string => {
  // Remove the # if present
  const hex = hexColor.replace('#', '');
  
  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Create lighter background color
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}; 